import { BoxMargin } from 'tabler-icons-react';
import {
  ECOM_ENTITY_TYPES,
  ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM
} from '../../../../../config/constants';
import WsCategoryBlock from './WsCategoryBlock';
import { PRODUCT_CATEGORY_LIST } from '../../../../../config/productCategories';

const configNameValues = { ecomCategory: 'ecomCategory' };

const configDefaultValues = { ecomCategory: '' };

const configOptions = {
  [configNameValues.ecomCategory]: {
    label: 'Category',
    type: 'entity',
    entityType: ECOM_ENTITY_TYPES.ecomCategory
  }
};

const config = {
  title: 'Category',
  type: ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM.CATEGORY,
  icon: BoxMargin,
  Component: WsCategoryBlock,
  configOptions,
  defaultConfig: configDefaultValues,
  getTitle: (c) =>
    PRODUCT_CATEGORY_LIST.find((cat) => cat.value.toString() === c.ecomCategory)
      ?.label || 'Category'
};

export { config, configOptions, configNameValues, configDefaultValues };
